<section>
  <div class="container-fluid">
    <div class="row mb-1">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="container-fluid">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Vendors</li>
            <li class="breadcrumb-item active">Create Vendor</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</section>

<section>
  <div class="row mb-1">
    <div class="col-sm-1"></div>
    <div class="col-sm-10 p-0">
      <div class="card Title-bar-blue">
        <div class="devcare-card-header">
          <span class="devcare-sub-header Title-bar-text">Create
            Vendor</span>
        </div>
        <div class="text-sm text-left">
        </div>
      </div>
    </div>
    <div class="col-sm-1"></div>
  </div>
</section>

<section>
  <form [formGroup]="createVendorForm" novalidate>
    <div class="row mb-1">
      <div class="col-sm-1"></div>
      <div class="col-sm-10 p-0">
        <div class="card vendor-company-profile">
          <div class="card-header">
            <span class="card-title">Company Profile</span>
          </div>
          <div class="card-body">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-4">
                <label class="required">Entity Type<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getEntityTypeOnChange($event)" [options]="entityTypes" placeholder="Select"
                  optionLabel="description" [(ngModel)]="selectedEntityTypeId" [ngModelOptions]="{standalone: true}">
                </p-dropdown>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Vendor Name<span class="required-field">*</span></label>
                <input class="form-control" id="disabled-input" maxlength="100" formControlName="vendorName"
                  (keyup)="onVendorAvailabilityCheck();preventSqlComments($event)" maxlength="100" type="text"
                  pInputText />
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.vendorName.touched) && createVendorFormControl.vendorName.errors?.required">
                </span>
                <span class="text-danger" *ngIf="vendorNameAvail">
                  Vendor Name already exists
                </span>
                <span class="text-danger" *ngIf="isSqlComments">
                  Please enter a valid Vendor Name
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Tax ID Number<span *ngIf="!forIndividual" class="required-field">*</span></label>
                <input type="text" class="form-control" formControlName="taxIdNumber"
                  (keyup)="onVendorAvailabilityCheck();onCheckTaxIdNumber()" mask='00-0000000' pInputText>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.taxIdNumber.touched) && createVendorFormControl.taxIdNumber.errors?.required">
                  Please enter a valid TIN
                </span>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.taxIdNumber.touched) && createVendorFormControl.taxIdNumber.errors?.minlength">
                  Please enter a valid TIN
                </span>
                <span class="text-danger" *ngIf="taxIdAvail">
                  TIN is already in use
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>SSN</label>
                <input type="text" class="form-control" formControlName="ssnNumber" [minLength]="9" (input)="validateInput($event)"
                mask='AAA-AA-AAAA'  pInputText>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.ssnNumber.touched) && createVendorFormControl.ssnNumber.errors?.minlength">
                  Please enter a valid SSN
                </span>
              </div>
              <!-- <div class="p-field p-col-12 p-md-4" *ngIf=disableVendorEmail>
                              <label for="vendorEmailId">Email Address<span class="required-field">*</span></label>
                              <input class="form-control" maxlength="100" formControlName="vendorEmailId"
                                (keyup)="onVendorEmailAvailabilityCheck()" type="email" pInputText disabled>
                            </div> -->
              <div class="p-field p-col-12 p-md-4">
                <label for="vendorEmailId">Email Address<span class="required-field">*</span></label>
                <input class="form-control" maxlength="100" formControlName="vendorEmailId"
                  (keyup)="onVendorEmailAvailabilityCheck();onVendorAvailabilityCheck()" type="email" pInputText>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.vendorEmailId.touched) && createVendorFormControl.vendorEmailId.errors?.required">
                </span>
                <span class="text-danger"
                  *ngIf="createVendorFormControl.vendorEmailId.touched && createVendorFormControl.vendorEmailId.errors?.email">
                  Please Enter a Valid Email Address
                </span>
                 <span class="text-danger"
                  *ngIf="createVendorFormControl.vendorEmailId.touched && createVendorFormControl.vendorEmailId.errors?.pattern">
                  Please Enter a Valid Email Address
                </span>
                <span class="text-danger" *ngIf="createVendorForm?.controls?.vendorEmailId?.hasError('emailInvalid')">
                  Please Enter a Valid Email Address<br />
                </span>
               <!-- <span class="text-danger"
                  *ngIf="createVendorForm?.controls?.vendorEmailId?.hasError('emailEntityInvalid')">
                  Please Enter your Business Email Address<br />
                </span> -->
                <span class="text-danger" *ngIf="vendorEmailAvail">
                  The Email is already in use
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="vendorPhoneNumber">Phone Number <span class="required-field">*</span></label>
                <input type="text" class="form-control" formControlName="vendorPhoneNumber" mask='(000) 000-0000'
                  (keyup)="vendorPhoneUniqueNumbers($event)" pInputText>
                <span class="text-danger" *ngIf="isVendorPhoneUniqueNumbers">
                  Please Enter Valid Phone Number
                </span>
                <span class="text-danger" *ngIf="isVendorPhoneNumberValid">
                  Please Enter Valid Phone Number
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4" *ngIf=vendorPhoneExtDisabled>
                <label for="VendorExtNumber">Extension Number</label>
                <input type="text" class="form-control" maxlength="6" formControlName="vendorPhoneExtNumber"
                  (keypress)="onlyNumbers($event)" pInputText disabled>
                <span class="text-danger"
                  *ngIf="createVendorFormControl.vendorPhoneExtNumber.touched && createVendorFormControl.vendorPhoneExtNumber.errors?.pattern">
                  Please Enter Valid Ext Number
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4" *ngIf=!vendorPhoneExtDisabled>
                <label for="VendorExtNumber">Extension Number</label>
                <input type="text" class="form-control" maxlength="6" formControlName="vendorPhoneExtNumber"
                  (keypress)="onlyNumbers($event)" pInputText>
                <span class="text-danger"
                  *ngIf="createVendorFormControl.vendorPhoneExtNumber.touched && createVendorFormControl.vendorPhoneExtNumber.errors?.pattern">
                  Please Enter Valid Ext Number
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="faxNumber">Fax Number </label>
                <input type="text" class="form-control" formControlName="faxNumber" mask='(000) 000-0000'
                  (keyup)="faxUniqueNumbers($event)" pInputText>
                <span class="text-danger" *ngIf="isFaxUniqueNumbers">
                  Please Enter Valid Fax Number
                </span>
                <span class="text-danger" *ngIf="isFaxNumberValid">
                  Please Enter Valid Fax Number
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Web Address</label>
                <input type="text" class="form-control" maxlength="100" formControlName="webAddress" pInputText>
                <!-- <span class="text-danger"
                                  *ngIf="(createVendorFormControl.webAddress.touched) && createVendorFormControl.webAddress.errors?.required">
                                </span> -->
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.webAddress.touched) && createVendorFormControl.webAddress.errors?.pattern">
                  Please enter a valid Web Address
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Address Line 1<span class="required-field">*</span></label>
                <input class="form-control" maxlength="100" formControlName="addressLine1" type="text" pInputText>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.addressLine1.touched) && createVendorFormControl.addressLine1.errors?.required">
                </span>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Address Line 2</label>
                <input class="form-control" maxlength="100" formControlName="addressLine2" maxlength="100" type="text"
                  pInputText>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="city">City<span class="required-field">*</span></label>
                <input type="text" class="form-control" maxlength="100" formControlName="city" pInputText>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="state">State<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getStateOnChange($event)" placeholder="Select a State"
                  [(ngModel)]="selectedStateId" [ngModelOptions]="{standalone: true}" [options]="states"
                  optionLabel="stateName">
                </p-dropdown>
              </div>
              <div class="p-field p-col-12 p-md-2">
                <label for="zipCode">Zip Code<span class="required-field">*</span></label>
                <input type="text" class="form-control" formControlName="zipCode" maxlength="5"
                  (keypress)="onlyNumbers($event)" (keyup)="enableZipCodeExt()" pInputText preventCutCopyPaste>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.zipCode.touched) && createVendorFormControl.zipCode.errors?.required">
                </span>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.zipCode.touched) && createVendorFormControl.zipCode.errors?.pattern">
                  Please enter valid zip code
                </span>
              </div>
              <div class="p-field p-col-12 p-md-2" *ngIf=!disabled>
                <label for="zipCode">Zip Code Ext</label>
                <input type="text" class="form-control" formControlName="zipCodeExt" maxlength="4"
                  (keypress)="onlyNumbers($event)" pInputText preventCutCopyPaste>
                <span class="text-danger"
                  *ngIf="(createVendorFormControl.zipCodeExt.touched) && createVendorFormControl.zipCodeExt.errors?.pattern">
                  Please enter valid zip code ext.
                </span>
              </div>
              <div class="p-field p-col-12 p-md-2" *ngIf=disabled>
                <label for="zipCode">Zip Code Ext</label>
                <input type="text" class="form-control" formControlName="zipCodeExt" maxlength="4"
                  (keypress)="onlyNumbers($event)" pInputText disabled>
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="selectedCountry">Country<span class="required-field">*</span></label>
                <p-dropdown id="selectedCountry" [options]="countries" optionLabel="name" [disabled]=true>
                </p-dropdown>
              </div>

              <div class="p-field p-col-12 p-md-4">
                <label for="paymentTerms">Payment Terms<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getPaymentTermsOnChange($event)" placeholder="Select a Payment Term"
                  [options]="paymentTerms" optionLabel="description">
                </p-dropdown>

              </div>
              <div  class="p-field p-col-12 p-md-4">
                <label for="distributionEmail">Distribution Email</label><br />
                <input class="form-control" maxlength="100" formControlName="distributionEmail"
                    type="email" pInputText>
                    <span class="text-danger"
                    *ngIf="(createVendorFormControl.distributionEmail.touched) && createVendorFormControl.distributionEmail.errors?.required">
                    </span>
                    <span class="text-danger"
                    *ngIf="createVendorFormControl.distributionEmail.touched && createVendorFormControl.distributionEmail.errors?.pattern">
                    Please Enter a Valid Email Address
                </span>
            </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Please select your vendor category<span class="required-field">*</span></label>
                <p-dropdown (onChange)="getClientListForRegistrationOnChange($event)"
                  [options]="clientListForRegistration" placeholder="Select" optionLabel="description">
                </p-dropdown>

              </div>
              <div class="p-field p-col-12 p-md-4">
                <label for="paymentTerms">Invoice Terms<span
                        class="required-field">*</span></label>
                <p-dropdown 
                    (onChange)="getInvoiceTermsOnChange($event)"
                   [(ngModel)]="selectedInvoiceTermsId"
                    [ngModelOptions]="{standalone: true}" [options]="invoiceTerms"
                    optionLabel="description">
                </p-dropdown>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label>Company Establishment(Year)</label><br />
              <input class="form-control" maxlength="4" (keypress)="onlyNumbers($event)"
                formControlName="companyEstablishment" type="text" pInputText preventCutCopyPaste>
              <!-- <span class="text-danger"
                *ngIf="(createVendorFormControl.companyEstablishment.touched) && createVendorFormControl.companyEstablishment.errors?.required">
              </span> -->
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="paymentTerms">MSA Type<span class="required-field">*</span></label>
              <p-dropdown (onChange)="getMSATypeOnChange($event)" [(ngModel)]="selectedMSATypeId" [disabled]=true
              [ngModelOptions]="{standalone: true}" placeholder="select"
                [options]="MSATypes" optionLabel="description">
              </p-dropdown>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="paymentTerms">Insurance Exhibit A<span
                      class="required-field">*</span></label>
              <p-dropdown 
                  (onChange)="getInsuranceExhibitOnChange($event)"
                 [(ngModel)]="selectedInsuranceExhibitId"
                  [ngModelOptions]="{standalone: true}" [options]="insuranceExhibit" [disabled]=true
                  optionLabel="description">
              </p-dropdown>
          </div>
            </div>
          </div>
        </div>

        <div class="card vendor-admin-details">
          <div class="card-header">
            <span class="card-title">Admin Details</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="firstName">First Name <span class="required-field">*</span></label>
                    <input type="text" maxlength="100" class="form-control"
                      (keyup)="preventSqlCommentsOnFirstName($event)" formControlName="firstName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnFirstName">
                      Please enter a valid First Name
                    </span>
                    <span class="text-danger"
                      *ngIf="(createVendorFormControl.firstName.touched) && createVendorFormControl.firstName.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="middleName">Middle Name</label>
                    <input type="text" maxlength="50" class="form-control"
                      (keyup)="preventSqlCommentsOnMiddleName($event)" formControlName="middleName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnMiddleName">
                      Please enter a valid Middle Name
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="lastName">Last Name <span class="required-field">*</span></label>
                    <input type="text" class="form-control" maxlength="100"
                      (keyup)="preventSqlCommentsOnLastName($event)" formControlName="lastName" pInputText>
                    <span class="text-danger" *ngIf="isSqlCommentsOnLastName">
                      Please enter a valid Last Name
                    </span>
                    <span class="text-danger"
                      *ngIf="(createVendorFormControl.lastName.touched) && createVendorFormControl.lastName.errors?.required">
                    </span>
                  </div>
                </div>
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label for="userEmailId">Email Address<span class="required-field">*</span></label>
                    <input class="form-control" maxlength="100" formControlName="adminEmailId"
                      (keyup)="onAdminEmailAvailabilityCheck()" type="email" pInputText>
                    <span class="text-danger"
                      *ngIf="(createVendorFormControl.adminEmailId.touched) && createVendorFormControl.adminEmailId.errors?.required">
                    </span>
                    <span class="text-danger"
                      *ngIf="createVendorFormControl.adminEmailId.touched && createVendorFormControl.adminEmailId.errors?.email">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="createVendorFormControl.adminEmailId.touched && createVendorFormControl.adminEmailId.errors?.pattern">
                      Please Enter a Valid Email Address
                    </span>
                    <span class="text-danger"
                      *ngIf="createVendorForm?.controls?.adminEmailId?.hasError('emailInvalid')">
                      Please Enter a Valid Email Address<br />
                    </span>
                    <!-- <span class="text-danger"
                      *ngIf="createVendorForm?.controls?.adminEmailId?.hasError('emailEntityInvalid')">
                      Please Enter your Business Email Address<br />
                    </span> -->
                    <span class="text-danger" *ngIf="adminEmailAvail">
                      The Email is already in use
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label for="PhoneNumber">Phone Number <span class="required-field">*</span></label>
                    <input type="text" class="form-control" formControlName="phoneNumber" mask='(000) 000-0000'
                      (keyup)="userPhoneUniqueNumbers($event)" pInputText>
                    <span class="text-danger" *ngIf="isUserPhoneUniqueNumbers">
                      Please Enter Valid Phone Number
                    </span>
                    <span class="text-danger" *ngIf="isUserPhoneNumberValid">
                      Please Enter Valid Phone Number
                    </span>
                    <span class="text-danger"
                      *ngIf="(createVendorFormControl.phoneNumber.touched) && createVendorFormControl.phoneNumber.errors?.required">
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=phoneExtDisabled>
                    <label for="extNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="extNumber"
                      (keypress)="onlyNumbers($event)" pInputText disabled>
                    <span class="text-danger"
                      *ngIf="createVendorFormControl.extNumber.touched && createVendorFormControl.extNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>
                  <div class="p-field p-col-12 p-md-4" *ngIf=!phoneExtDisabled>
                    <label for="extNumber">Extension Number</label>
                    <input type="text" class="form-control" maxlength="6" formControlName="extNumber"
                      (keypress)="onlyNumbers($event)" pInputText>
                    <span class="text-danger"
                      *ngIf="createVendorFormControl.extNumber.touched && createVendorFormControl.extNumber.errors?.pattern">
                      Please Enter Valid Ext Number
                    </span>
                  </div>





                </div>
              </div>
            </div>
          </div>
        </div>
         <div class="card vendor-admin-details">
          <div class="card-header">
            <span class="card-title">Onboarding Documents</span>
          </div>
          <div class="row">
            <div class="col-lg-12">
              <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-6">
                  
                </div>
                <div class="p-field p-col-12 p-md-6">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-5 p-md-5"></div>
                    <div class="p-field p-col-5 p-md-5">
                      <label>Certificate of Insurance </label>
                    </div>
                    <div class="p-field p-col-6 p-md-2">
                      <button pButton pRipple type="button" class="p-button-outlined p-button-sm"
                        [icon]="isShowCertificateofInsurance === true ? 'pi pi-minus' : 'pi pi-plus'"
                        (click)="isShowCertificateofInsurance = !isShowCertificateofInsurance"></button>
                    </div>
                  </div>
                </div>
               
              </div>
              <!--starts-->
              <!-- <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-6 p-md-3">
                  <label>Certificate of Insurance</label>
                </div>
                <div class="p-field p-col-6 p-md-2">
                  <button pButton pRipple type="button" class="p-button-outlined p-button-sm"
                    [icon]="isShowCertificateofInsurance === true ? 'pi pi-minus' : 'pi pi-plus'"
                    (click)="isShowCertificateofInsurance = !isShowCertificateofInsurance"></button>
                </div>
                <div class="p-field p-col-6 p-md-7"></div>
              </div> -->
              <div class="row"  *ngIf="isShowCertificateofInsurance">
                <div class="col-md-1"></div>
                <div class="col-md-10">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                      <span class="text-center"><u>Certification of Insurance (DevCare Clients)</u></span>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-4">
                      <div class="p-text-bold">Client Name</div>
                      <div class="p-mb-3 p-text-normal">DevCare Clients</div>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                      <div class="p-text-bold">Client Address</div>
                      <div class="p-text-normal">579 Executive Campus Drive,</div>
                      <div class="p-text-normal">Suite 370 • Westerville,</div>
                      <div class="p-text-normal">OH – 43082</div>
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                      <div class="p-text-bold">Certificate Holder</div>
                      <div class="p-text-normal">DevCare Solutions Ltd</div>
                      <div class="p-text-normal">579 Executive Campus Drive,</div>
                      <div class="p-text-normal">Suite 370 • Westerville,</div>
                      <div class="p-text-normal">OH – 43082</div>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                      <div class="p-text-bold">Additional Insured Section</div>
                      <div class="p-mb-3 p-text-normal">Certificate Holder is named as Additional Insured as their
                        interests may appear in regards to general liability</div>
                    </div>
                  </div>
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                      <div class="p-text-bold">Insurance Requirements</div>
                      <div class="p-mb-3 p-text-normal">Please provide a certificate of insurance, with expiration dates
                        at least 30 days from today’s date, with the following coverage levels</div>
                    </div>
                  </div>
                  <div>
                    <table class="table table-responsive ">
                      <thead>
                        <tr>
                          <th>Type of Insurance</th>
                          <th>Limit</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td rowspan="6">Commercial General Liability (General aggregate limit applier per policy)</td>
                          <td>Each Occurrence</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td>Damage to rental premises (Each occurrence)</td>
                          <td>$300,000</td>
                        </tr>
                        <tr>
                          <td>Medical Expense (Any one person)</td>
                          <td>$10,000</td>
                        </tr>
                        <tr>
                          <td>Personal & ADV Injury</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td>General aggregate</td>
                          <td>$2,000,000</td>
                        </tr>
                        <tr>
                          <td>Products – Comp/OP Agg</td>
                          <td>$2,000,000</td>
                        </tr>
                        <tr>
                          <td>Automobile Liability (Hired & Non-owned Autos)</td>
                          <td>Combined Single Limit (Each accident)</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td rowspan="2">Umbrella Liability</td>
                          <td>Each occurrence</td>
                          <td>$5,000,000</td>
                        </tr>
                        <tr>
                          <td>Aggregate</td>
                          <td>$5,000,000</td>
                        </tr>
                        <tr>
                          <td rowspan="3">Worker’s compensation and employer’s liability</td>
                          <td>EL Each accident</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td>EL Disease – EA Employee</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td>EL Disease – Policy limit</td>
                          <td>$1,000,000</td>
                        </tr>
                        <tr>
                          <td>Professional Liability - Errors & Omissions</td>
                          <td>Occurrence /
                            Aggregate</td>
                          <td>$5,000,000/
                            $5,000,000</td>
                        </tr>
                        <tr>
                          <td>Fidelity Bond 3rd party BKT</td>
                          <td>Each occurrence</td>
                          <td>$2,000,000</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="col-md-1"></div>
              </div>
              <div *ngIf="isShowCertificateofInsurance">                 
                <!--starts-->
                <div class="card-body">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-3">
                    <label> General Liability Eff Date </label>
                    <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="glEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label>General Liability Exp Date</label>
                    <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="glExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label> Automobile Liability Eff Date </label>
                    <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="alEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label>Automobile Liability Exp Date</label>
                    <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="alExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                </div>
                </div>
                <div class="card-body">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-3">
                    <label> Umbrella Liability Eff Date</label>
                    <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="ulEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label>Umbrella Liability Exp Date</label>
                    <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="ulExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label> Workers Compensation Eff Date </label>
                    <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="wcEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label>Workers Compensation Exp Date</label>
                    <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="wcExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                </div>
              </div>
                <div class="card-body">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-3">
                    <label> Professional Liability Eff Date</label>
                    <p-calendar [showIcon]="true" type="date" [maxDate]="minExpDate" formControlName="plEffDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label>Professional Liability Exp Date</label>
                    <p-calendar [showIcon]="true" type="date" [minDate]="minExpDate" formControlName="plExpDate" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" inputId="navigators">
                    </p-calendar>
                  </div>
                </div>
                </div>
                <div class="card-body">
                <div class="p-fluid p-formgrid p-grid">
                  <div class="p-field p-col-12 p-md-12">
                    <label>Comments</label>
                    <br>
                    <textarea formControlName="comments" maxlength="1000" pInputTextarea
                      class="form-control"></textarea>
                  </div>
                </div>
                </div>

              </div>
              <!--ends-->
              <div class="card">
                <div class="card-body">
                  <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                      <div class="card">
                        <div class="card-header">
                          <label>COI Form</label>
                          <button pButton pRipple [disabled]="!showCOIFormFilePreviewEnable" type="button" icon="pi pi-eye" (click)="ShowInsuranceUploadedFile()"
                            class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>
                        </div>
                        <div class="card-body  text-center" style="height: 70px;">
                          <div class="vms-file-upload">
                            <input type='file' id="InsuranceUpload" (change)="onInsuranceSelect($event)"
                              style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #InsuranceUpload />
                            <div>
                              <button pButton pRipple type="button" label="Upload" icon="pi pi-upload"
                                class="p-button-raised" style="width: fit-content;height: 30px;"
                                (click)="InsuranceUpload.click()"></button><br /> <br />
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <small class="text-sm"
                            [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">{{Insurancefileuploadmessage}}</small>
                          <!-- <small class="text-bold text-sm text-primary"  [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">
                          {{Insurancefileuploadmessage}}
                        </small> -->
                        </div>
                      </div>
                    </div>
                    <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                      <div class="card">
                        <div class="card-header">
                          <label>W9 Form</label>
                          <button pButton pRipple type="button" [disabled]="!showW9FormFilePreviewEnable" (click)="Showw9UploadedFile()" icon="pi pi-eye"
                            class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>
                        </div>
                        <div class="card-body  text-center" style="height: 70px;">
                          <div class="vms-file-upload">
                            <input type='file' id="W9FormUpload" (change)="onW9FormSelect($event)"
                              style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #W9FormUpload />
                            <div>
                              <button pButton pRipple type="button" icon="pi pi-upload" label="Upload"
                                class="p-button-raised" style="width: fit-content;height: 30px;"
                                (click)="W9FormUpload.click()"></button><br /> <br />
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <small class="text-sm"
                            [ngClass]="isw9fileShowsuccessmsg== true ? 'label-success': 'label-error'">{{w9fileuploadmessage}}</small>

                        </div>
                      </div>
                    </div>
                    <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                      <div class="card">
                        <div class="card-header">
                          <label>DD Authorization </label>
                          <button pButton pRipple type="button"  [disabled]="!showDDFormFilePreviewEnable" (click)="ShowDDAuthorizationUploadedFile()"
                            icon="pi pi-eye" class="p-button-raised"
                            style="float: right;border-radius: 50%;height: 30px;"></button>
                        </div>
                        <div class="card-body  text-center" style="height: 70px;">
                          <div class="vms-file-upload">
                            <input type='file' id="DDAutorizationUpload" (change)="onDDAutorizationSelect($event)"
                              style="display: none;" accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #DDAutorizationUpload />
                            <div>
                              <button pButton pRipple type="button" icon="pi pi-upload" label="Upload"
                                class="p-button-raised" style="width: fit-content;height: 30px;"
                                (click)="DDAutorizationUpload.click()"></button><br /> <br />
                            </div>
                          </div>
                        </div>
                        <div class="card-footer">
                          <small class="text-sm"
                            [ngClass]="isDDfileShowsuccessmsg== true ? 'label-success': 'label-error'">{{DDfileuploadmessage}}</small>

                        </div>
                      </div>
                    </div>
                    <!-- <div class="p-field p-col-12 col-md-3 col-sm-3 col-lg-3">
                    <div class="card">
                      <div class="card-header">
                        <label><a href="../../../../assets/pdf/MSA.pdf" target="_blank">Download MSA</a></label>
                        <button pButton pRipple type="button" (click)="ShowMSAUploadedFile()" icon="pi pi-eye"
                        class="p-button-raised"  style="float: right;border-radius: 50%;height: 30px;"></button>
                      </div>
                      <div class="card-body  text-center" style="height: 70px;">
                        <div class="vms-file-upload">
                          <input type='file' id="MSAUpload" (change)="onMSASelect($event)" style="display: none;"
                            accept=".pdf" #MSAUpload />
                          <div>
                            <button pButton pRipple type="button" label="Upload" icon="pi pi-upload" class="p-button-raised"
                              style="width: fit-content;height: 30px;" (click)="MSAUpload.click()"></button><br /> <br />
                          </div>
                        </div>
                      </div>
                      <div class="card-footer">
                        <small class="text-bold text-sm text-primary"
                          [ngClass]="isInsurancefileShowsuccessmsg == true ? 'label-success': 'label-error'">{{MSAfileuploadmessage}}</small>
                      </div>
                    </div>
                  </div> -->
                  <div class="p-field p-col-12 col-md-6 col-sm-6 col-lg-6">
                    <div class="card">
                      <div class="card-header" style="height: 49px;">
                        <label>Master Service Agreement  &nbsp;&nbsp;</label>
                        <img src="../../../../assets/img/exclamatoryFinal.png" width="20px" height="20px" hideDelay="5000" pTooltip="{{msaTooltipMsg}}" tooltipPosition="top">
                        <!-- <button pButton pRipple type="button" hideDelay="10000" pTooltip="{{msaTooltipMsg}}" tooltipPosition="right" icon="pi pi-exclamation-circle" class="p-button-rounded p-button-warning"></button> -->
                        <div class="p-d-flex p-jc-between" style="float: right;">
                          <a href="../../../../assets/pdf/MSA.pdf" target="_blank">
                            <button pButton pRipple type="button" label="Secondary" class="p-button-raised p-button-secondary" style="width: fit-content;height:30px;float:right;" icon="pi pi-download" label="MSA"></button>                          
                          </a> &nbsp;&nbsp;
                          <button pButton pRipple type="button"  [disabled]="!showMSAFormFilePreviewEnable" (click)="ShowMSAUploadedFile()" icon="pi pi-eye"
                        class="p-button-raised" style="float: right;border-radius: 50%;height: 30px;"></button>                         
                        </div>
                      </div>
                      <div class="card-body text-center" style="height: 75px;">
                        <!-- <small class="form-text text-muted" style="font-size: 15px;">This document requires your
                          signature.Please download the given
                          document,complete the necessary information, sign it, and upload it back to us</small> -->
                        <!-- <p-divider></p-divider> -->
                        <div class="vms-file-upload">
                          <input type='file' id="MSAUpload" (change)="onMSASelect($event)" style="display: none;"
                            accept=".doc, .docx, .pdf,.xls,.xlsx,.Pdf,.PDF" #MSAUpload />
                          <div class="text-center">
                            <button pButton pRipple type="button" label="Upload" icon="pi pi-upload" class="p-button-raised"
                              style="width: fit-content;height: 30px;" (click)="MSAUpload.click()"></button><br /> <br />
                          </div>
                        </div>
                      </div>
                      <div class="card-footer">
                        <small class="text-sm"
                          [ngClass]="isMSAfileShowsuccessmsg== true ? 'label-success': 'label-error'">{{MSAfileuploadmessage}}</small>                         
                      </div>
                    </div>
                  </div>
                  </div>
                </div>
                <!-- <div class="card-footer">
                <label>Master Service Agreement (MSA)<span *ngIf="!forIndividual" class="required-field">*</span></label>
                <label class="border border-info p-p-1 bg-secondary" style="float: right;border-radius: 5px;"><a href="../../../../assets/pdf/MSA.pdf" target="_blank">Download MSA</a></label>
              <small class="form-text text-muted" style="font-size: 14px;">This document requires your signature.Please download the given
                document,complete the necessary information, sign it, and upload it back to us</small>
               </div> -->
              </div>                

            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </form>
</section>

<section>
  <p-toast [baseZIndex]="100001" position="bottom-center" key="save"></p-toast>
  <div class="p-fluid p-formgrid p-grid">
    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4"></div>
    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4">
      <div class="d-flex p-jc-between">
        <button pButton pRipple type="button" label="Save" icon="pi pi-check"
          [disabled]="!createVendorForm.valid || !isSaveAvailable || vendorNameAvail || vendorEmailAvail || adminEmailAvail || isSqlCommentsOnFirstName 
                    || isSqlCommentsOnMiddleName || isUserPhoneNumberValid || isUserPhoneUniqueNumbers ||entityTypeEnable ||paymentTermsEnable||!isValidateVendorCategory ||emailEntityInvalid"
          class="p-button-outlined p-button-sm p-button-success float-right m-2 bg-success"
          (click)="save(createVendorForm)"></button>
        <button pButton pRipple type="button" label="Cancel" icon="pi pi-times"
          class="p-button-outlined p-button-sm p-button-danger float-right m-2 bg-primary"
          (click)="onCancelVendorForm()"></button>
      </div>
    </div>
    <div class="p-field p-col-12 col-sm-4 col-md-4 col-lg-4"></div>

  </div>
</section>
<p-toast [baseZIndex]="100001" position="bottom-center" key="w9"></p-toast>
<!-- <p-dialog  [(visible)]="showPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-toast position="bottom-center" key="w9"></p-toast>
<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="w9FileDisplayName" target="_blank" [href]="w9FileDocUrl" *ngIf="showW9FormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showW9FormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showW9FormFilePreview" [url]="w9FileDocUrl" disableContent="popout"
              viewer="google" style="width:100%;height:80vh;">
          </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="dd"></p-toast>
<!-- <p-dialog  [(visible)]="showDDPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-toast position="bottom-center" key="dd"></p-toast>
<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="ddAuthorizationFileDisplayName" target="_blank" [href]="ddFileDocUrl" *ngIf="showDDFormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showDDFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showDDFormFilePreview" [url]="ddFileDocUrl" disableContent="popout"
                 viewer="google" style="width:100%;height:80vh;">
             </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="msa"></p-toast>
<!-- <p-dialog [(visible)]="showMSAPreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-toast position="bottom-center" key="msa"></p-toast>
<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="msaFileDisplayName" target="_blank" [href]="msaFileDocUrl" *ngIf="showMSAFormFilePreviewEnable"><i class="fa fa-download" aria-hidden="true"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showMSAFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showMSAFormFilePreview" [url]="msaFileDocUrl" disableContent="popout"
                viewer="google" style="width:100%;height:80vh;">
              </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->

<p-toast [baseZIndex]="100001" position="bottom-center" key="coi"></p-toast>
<!-- <p-dialog [(visible)]="showInsurancePreview" [modal]="true" [style]="{width: '70vw',height:'80vh',overflow:'hidden',top:'7px'}"
[draggable]="false" [resizable]="false">
<p-toast position="bottom-center" key="coi"></p-toast>
<ng-template pTemplate="header" class="font-accordion"><span>File Preview &nbsp;<a [download]="insuranceFileDisplayName" target="_blank" [href]="coiFileDocUrl"><i class="fa fa-download" aria-hidden="true" *ngIf="showCOIFormFilePreviewEnable"></i></a></span>
</ng-template>
  <br>
  <div class="card p-p-2">
      <div class="card-header">
      </div>     
      <div class="card-footer">
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-5 col-md-5 col-sm-5"></div>
            <div class="p-field p-col-2 col-md-2 col-sm-2">
              <p-progressSpinner  [style]="{height:'80vh'}" class="p-ai-center" *ngIf="!showCOIFormFilePreview"></p-progressSpinner>
          </div>
          <div class="p-field p-col-5 col-md-5 col-sm-5"></div>               
          <div class="p-field p-col-12 col-md-12 col-sm-12">
              <ngx-doc-viewer *ngIf="showCOIFormFilePreview" [url]="coiFileDocUrl" disableContent="popout"
                viewer="google" style="width:100%;height:80vh;">
              </ngx-doc-viewer>
          </div>
        </div> 
      </div>
  </div>
</p-dialog> -->
<p-confirmDialog key="businessEmail" header="Confirmation" [style]="{width: '50vw'}" [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text" #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="pi pi-times" label="No, I don't have a work email "
      (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Yes, I have a work email" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>